import { render, staticRenderFns } from "./DialogOrders.vue?vue&type=template&id=b79d1802&scoped=true"
import script from "./DialogOrders.vue?vue&type=script&lang=js"
export * from "./DialogOrders.vue?vue&type=script&lang=js"
import style0 from "./DialogOrders.vue?vue&type=style&index=0&id=b79d1802&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79d1802",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b79d1802')) {
      api.createRecord('b79d1802', component.options)
    } else {
      api.reload('b79d1802', component.options)
    }
    module.hot.accept("./DialogOrders.vue?vue&type=template&id=b79d1802&scoped=true", function () {
      api.rerender('b79d1802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/ensureUserManagement/components/DialogOrders.vue"
export default component.exports